<h2 mat-dialog-title>AI Assistent</h2>
<div mat-dialog-content>
  @for (message of filteredMessages; track message) {
  <div>
    <strong>{{ translateRole(message.role) }}:</strong>
    <p [innerHTML]="parseMarkdown(message.content)"></p>
  </div>
  }

  @if (streamingMessage) {
  <div>
    <strong>Assistent:</strong>
    <p [innerHTML]="parseMarkdown(streamingMessage)"></p>
  </div>
  }
</div>
<div mat-dialog-actions>
  <mat-form-field style="width: 100%;">
    <input matInput [(ngModel)]="userInput" (keyup.enter)="sendStreamingMessage()" placeholder="Type je bericht..." cdkFocusInitial />
  </mat-form-field>
  <button mat-button (click)="onNoClick()">Sluiten</button>
</div>